<template>
	<Container>
		<div class="flex" :class="[adminMenu ? 'flex-row' : 'flex-col']">
			<MenuAdmin class="w-1/5" />
			<transition name="fade">
				<router-view class="w-full" />
			</transition>
		</div>
	</Container>
</template>

<script>
import MenuAdmin from '@/components/Menuadmin.vue'
import { mapGetters } from 'vuex'

export default {
	components: {
		MenuAdmin
	},
	computed: {
		...mapGetters({
			adminMenu: 'adminMenu'
		})
	}
}
</script>
